
import { useCallback, useReducer, useRef } from 'react'
// import moment from 'moment/moment'
// import { v4 as uuidv4 } from 'uuid'

import { Model } from '../../../models/model'

const initialState = {
    months_report: [],
    data_report: [],
    hasControlledAccounts: undefined,
    reportStatus: "loading",
    savedOK: false
}

const REDUCER = (state = [], action) => {
    switch (action.type) {
        case 'load_report':
            return { ...state, reportStatus: 'loading' }

        case 'receive_report':
            return {
                ...state,
                months_report: action.payload?.months || [],
                data_report: action.payload?.data || [],
                hasControlledAccounts: action.payload?.hasControlledAccounts,
                reportStatus: action.payload ? 'ready' : 'error'
            }

        case 'update_data':
            return {
                ...state,
                data_report: action.payload
            }

        case 'update_saved_ok':
            return {
                ...state,
                savedOK: action.payload
            }

        default:
            return state
    }
}

export const useFlow = () => {

    const [state, dispatch] = useReducer(REDUCER, initialState)
    const { months_report, data_report, savedOK, hasControlledAccounts, reportStatus } = state
    const latestRequest = useRef(0)

    const initGetAllFlowNew = useCallback(async (filtersParams = {}) => {

        const request = ++latestRequest.current
        dispatch({ type: 'load_report' })
        const filters = {
            mode: 'global',
            project_id: 0,
            ...filtersParams
        }

        const urlReport = (filters.cash_flow_type === 'flujo_caja' ? 'reports/cashflow/new/?' : 'reports/cashflow/new/efectivo/?')

        const params = (new URLSearchParams(filters)).toString()
        const results = await Model.getAll({
            url: `${urlReport}${params}`,
        })

        if (request !== latestRequest.current) return
        dispatch({
            type: 'receive_report',
            payload: Array.isArray(results?.months) && Array.isArray(results?.data) ? results : null
        })

    }, [])

    const initEditFlow = async (values, valueId, flowId) => {
        const newAmount = values.floatValue

        const flowUpdated = data_report?.map(flow => {
            if (parseFloat(flow.id) === parseFloat(flowId)) {

                const valuesUpdated = flow.values.map(itemValue => {
                    if (parseFloat(itemValue.id) === parseFloat(valueId)) {
                        return {
                            ...itemValue,
                            value: newAmount,
                            edited: true
                        }
                    }

                    return itemValue
                })

                return {
                    ...flow,
                    values: valuesUpdated
                }

            }

            return flow

        })

        dispatch({
            type: 'update_data',
            payload: flowUpdated
        })

    }

    const initSaveChanges = async () => {

        await Model.save({
            url: `reports/cashflow`,
            dataForm: {
                data_values: data_report
            }
        })

        initGetAllFlowNew()
        initSavedOK(!savedOK)

    }

    const initSavedOK = async (newStatus) => {
        dispatch({
            type: 'update_saved_ok',
            payload: newStatus
        })
    }

    return {
        initGetAllFlowNew,
        initSavedOK,
        initEditFlow,
        initSaveChanges,
        months_report,
        data_report,
        hasControlledAccounts,
        reportStatus,
        savedOK
    }

}